import {NoteBookReducer} from './NoteBookReducer';
import {
  createStore
} from 'redux';
import {combineReducers} from 'redux';
import {INITIAL_STATE} from './InitialState';
import {SimulationLevelReducer} from './SimulationLevelReducer';
//import {LevelReducer} from './LevelReducer';
import {SlideOneReducer} from './SlideOneReducer';
import {SlideTwoReducer} from './SlideTwoReducer';
import {CSCQReducer} from './CSCQReducer';
import {OEQReducer} from './OEQReducer';
import {NEQReducer} from './NEQReducer';
import {DDQReducer} from './DDQReducer';
import {DNDQReducer} from './DNDQReducer';
import {MSCQReducer} from './MSCQReducer';

import {SlideThreeReducer} from './SlideThreeReducer';

// TODO
import {GelDragDropQuestionReducer} from './GelDragDropQuestionReducer';
import {ColorPredictionReducer} from './ColorPredictionReducer';
import {PredictedQuestionTableReducer} from './PredictedQuestionTableReducer';

// -- Remove and clean out this state props -- //
import {ProtocolReducer} from './ProtocolReducer';
// -- -- //
import {ModalReducer} from './ModalReducer';
import {UndoReducer} from './UndoReducer';

import {PipetteReducer} from './PipetteReducer';
import {TipBoxReducer} from './TipBoxReducer';
import {TrashReducer} from './TrashReducer';
import {SolutionReducer} from './SolutionReducer';
import {MicrocentrifugeReducer} from './MicrocentrifugeReducer';
import GelBoxReducer from './GelBoxReducer';
import PowerSupplyReducer from './PowerSupplyReducer';
import AgaroseGelReducer from './AgaroseGelReducer';
import RotorAdapterReducer from './RotorAdapterReducer';
import PowerSupplyLeadReducer from './PowerSupplyLeadReducer';
//import FlaskReducer from './FlaskReducer';
import WaterBathReducer from './WaterBathReducer';
import TransilluminatorReducer from './TransilluminatorReducer';
import FloatingTubeRackReducer from './FloatingTubeRackReducer';
import MarkerReducer from './MarkerReducer';
import {IceBucketReducer} from './IceBucketReducer';
import {ThermocyclerReducer} from './ThermocyclerReducer';
import {HeatBlockReducer} from './HeatBlockReducer';
import {PosterReducer} from './PosterReducer';

import {PageTourReducer} from './PageTourReducer';

import {BoxReducer} from './BoxReducer';
import {CuvetteRackReducer} from './CuvetteRackReducer';
import {CuvetteReducer} from './CuvetteReducer';
import {LightReducer} from './LightReducer';
import {ExperimentPosterReducer} from './ExperimentPosterReducer';
import {GlassTubeReducer} from './GlassTubeReducer';
import {PlantTankReducer} from './PlantTankReducer';
import {BoxHolderReducer} from './BoxHolderReducer';
import {PlantReducer} from './PlantReducer';
import {SpectrophotometerReducer} from './SpectrophotometerReducer';
import {StopperReducer} from './StopperReducer';
import {CuvetteSealReducer} from './CuvetteSealReducer';
import {TimerReducer} from './TimerReducer';
import {AbsorbanceTableReducer} from './AbsorbanceTableReducer';

const notebookReducer = (state = INITIAL_STATE, action) => {
  state = NoteBookReducer(state, action);
  //state = LevelReducer(state, action);
  state = SimulationLevelReducer(state, action);
  state = SlideOneReducer(state, action);
  state = SlideTwoReducer(state, action);
  state = CSCQReducer(state, action);
  state = OEQReducer(state, action);
  state = NEQReducer(state, action);
  state = DDQReducer(state, action);
  state = DNDQReducer(state, action);
  state = MSCQReducer(state, action);
  state = SlideThreeReducer(state, action);

  state = GelDragDropQuestionReducer(state, action);
  state = ColorPredictionReducer(state, action);
  state = PredictedQuestionTableReducer(state, action);

  state = ProtocolReducer(state, action);
  state = ModalReducer(state, action);
  state = UndoReducer(state, action);

  state = PipetteReducer(state, action);
  state = TipBoxReducer(state, action);
  state = TrashReducer(state, action);
  state = SolutionReducer(state, action);
  state = MicrocentrifugeReducer(state, action);
  state = IceBucketReducer(state, action);
  state = ThermocyclerReducer(state, action);
  state = HeatBlockReducer(state, action);
  state = GelBoxReducer(state, action);
  state = PowerSupplyReducer(state, action);
  state = PowerSupplyLeadReducer(state, action);
  //state = FlaskReducer(state, action);
  state = FloatingTubeRackReducer(state, action);
  state = WaterBathReducer(state, action);
  state = TransilluminatorReducer(state, action);
  state = MarkerReducer(state, action);
  state = AgaroseGelReducer(state, action);
  state = RotorAdapterReducer(state, action);
  state = BoxReducer(state, action);
  state = CuvetteRackReducer(state, action);
  state = CuvetteReducer(state, action);
  state = LightReducer(state, action);
  state = ExperimentPosterReducer(state, action);
  state = GlassTubeReducer(state, action);
  state = PlantTankReducer(state, action);
  state = BoxHolderReducer(state, action);
  state = PlantReducer(state, action);
  state = SpectrophotometerReducer(state, action);
  state = StopperReducer(state, action);
  state = CuvetteSealReducer(state, action);
  state = TimerReducer(state, action);
  state = AbsorbanceTableReducer(state, action);
  state = PosterReducer(state, action);
  state = PageTourReducer(state, action);

  return {...state};
};

const rootReducer = combineReducers({
  notebook: notebookReducer
});

export const Store = createStore(rootReducer);
